import { motion, Transition, Variants } from 'framer-motion'
import { twMerge } from 'tailwind-merge'

const DOT_BOUNCE_DURATION = 0.3
const DOT_COUNT = 3

const reconnectingContainerTransition: Transition = {
  staggerChildren: DOT_BOUNCE_DURATION,
}

const reconnectingDotTransition: Transition = {
  duration: DOT_BOUNCE_DURATION,
  repeat: Infinity,
  repeatDelay: (DOT_COUNT - 1) * DOT_BOUNCE_DURATION,
  ease: 'easeInOut',
}

const reconnectingDotVariants: Variants = {
  animate: {
    y: [0, -3, 0],
  },
}

interface ReconnectingDotsProps {
  className?: string
}

export function ReconnectingDots({ className }: ReconnectingDotsProps) {
  return (
    <motion.div
      className={twMerge('flex h-[20px] shrink-0 items-center gap-0.5', className)}
      animate="animate"
      transition={reconnectingContainerTransition}
    >
      {Array.from({ length: DOT_COUNT }, (_, i) => i).map((i) => (
        <motion.div
          key={i}
          className="bg-warning h-1 w-0.5 rounded-full"
          variants={reconnectingDotVariants}
          transition={reconnectingDotTransition}
        />
      ))}
    </motion.div>
  )
}
